/**
 * Pre-flight readiness for one aircraft.
 *
 * The verdict is computed server-side from the same snapshot the map is drawn
 * from, so the panel cannot disagree with the fleet state next to it.
 */

import { api, type ApiResult } from '@/api/client';

export type CheckStatus = 'pass' | 'warn' | 'fail' | 'unknown';

export interface ReadinessCheck {
  key: string;
  label: string;
  status: CheckStatus;
  detail: string;
}

export interface Readiness {
  droneId: string;
  /** True only when nothing failed. A warn is the operator's call. */
  cleared: boolean;
  /** Signal-over-noise in the worse direction. Null when the link is not a radio. */
  linkMarginDb: number | null;
  checks: ReadinessCheck[];
}

export function getPreflight(droneId: string): Promise<ApiResult<Readiness>> {
  return api.get<Readiness>(`/preflight/${encodeURIComponent(droneId)}`, { logged: false });
}
